//
// GENERATED by KVision
//
package pl.finn.forms

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class FormsService : IFormsService

object FormsServiceManager : KVServiceManager<FormsService>(FormsService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(IFormsService::anuluj, HttpMethod.POST, null)
    }
}
